/**
 * @license
 * Copyright (c) 2021 - 2026 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */

/**
 * @note Taken from Gaël Poupard gist
 * @author Gaël Poupard
 * @see https://gist.github.com/ffoodd/000b59f431e3e64e4ce1a24d5bb36034
 */
import { css } from 'lit';

export const screenReaderOnly = css`
  .sr-only {
    border: 0 !important;
    clip: rect(1px, 1px, 1px, 1px) !important;
    clip-path: inset(50%) !important;
    height: 1px !important;
    margin: -1px !important;
    overflow: hidden !important;
    padding: 0 !important;
    position: absolute !important;
    width: 1px !important;
    white-space: nowrap !important;
  }
`;
